// externals
import type { DealType, IncentiveType } from '@makemydeal/dr-shared-bff-types';

// action types (owned locally; string values match the host store's — see actionTypes.ts)
import {
    GET_DEAL_SUMMARY_PDF,
    OPEN_REQUEST_CHANGE_MODAL,
    REQUEST_PROPOSAL_RESET,
    REQUEST_PROPOSAL_TOGGLE_DEAL_TYPE,
    REQUEST_PROPOSAL_TOGGLE_INCENTIVE,
    REQUEST_PROPOSAL_UPDATE_NOTES,
    SHOW_CONFETTI,
    ACCEPT_DEAL_SUMMARY_REQUEST,
    REQUEST_PROPOSAL_SEND_REQUEST_CLICKED,
    REQUEST_PROPOSAL_ACCEPT_DEAL_CLICKED,
    SEND_DEAL_SUMMARY_REQUEST_LOADER,
    DEAL_PDF_LOADED_SUCCESS
} from './actionTypes';

// action creators

export const getDealSummaryPDF = () => {
    return {
        type: GET_DEAL_SUMMARY_PDF
    };
};

export const toggleDealType = (dealType: DealType[]) => ({
    type: REQUEST_PROPOSAL_TOGGLE_DEAL_TYPE,
    payload: dealType
});

export const toggleIncentive = (incentive: IncentiveType[]) => ({
    type: REQUEST_PROPOSAL_TOGGLE_INCENTIVE,
    payload: incentive
});

export const updateNotes = (notes: string) => ({
    type: REQUEST_PROPOSAL_UPDATE_NOTES,
    payload: notes
});

export const resetRequestProposalStatus = () => ({
    type: REQUEST_PROPOSAL_RESET
});

export const openRequestChangeModal = (isOpen: boolean) => ({
    type: OPEN_REQUEST_CHANGE_MODAL,
    payload: isOpen
});

export const setShowConfetti = (payload: boolean) => ({
    type: SHOW_CONFETTI,
    payload
});

export const showAcceptDealLoader = () => ({
    type: ACCEPT_DEAL_SUMMARY_REQUEST
});

export const requestProposalSendRequestClicked = () => ({ type: REQUEST_PROPOSAL_SEND_REQUEST_CLICKED });

export const requestProposalAcceptDealClicked = () => ({ type: REQUEST_PROPOSAL_ACCEPT_DEAL_CLICKED });

export const showSendDealRequestLoader = () => ({
    type: SEND_DEAL_SUMMARY_REQUEST_LOADER
});

export const isDealPdfLoading = (payload: boolean) => ({
    type: DEAL_PDF_LOADED_SUCCESS,
    payload
});
